import Card from 'antd/lib/card';
import Col from 'antd/lib/col';
import Statistic from 'antd/lib/statistic';
import clsx from 'clsx';
import React, { ReactElement, useCallback, useMemo } from 'react';

import { IDeliveryGridItemTileProps } from './DeliveryGridItem.types';
import classes from './DeliveryGridItemTile.module.css';

const DeliveryGridItemTile = ({
  deliveryStats,
  flow,
  getProps,
  title,
  colSpan = 6,
}: IDeliveryGridItemTileProps): ReactElement => {
  const { cardClass, customTitle, statisticClass, suffix, value, valueCustomRender } = useMemo(
    () => getProps(deliveryStats, flow),
    [deliveryStats, flow, getProps],
  );

  const valueRender = useCallback(
    () => <span className={statisticClass || classes.statistic}>{value}</span>,
    [value, statisticClass],
  );

  return (
    <Col span={colSpan}>
      <Card className={clsx(classes.gridCard, cardClass)}>
        <div>
          <Statistic
            className={classes.centerText}
            suffix={suffix || ''}
            value={value || ''}
            valueRender={valueCustomRender || valueRender}
          />
          <div className={classes.bottomLine}>{customTitle || title}</div>
        </div>
      </Card>
    </Col>
  );
};

export default DeliveryGridItemTile;
